module.exports = __webpack_public_path__ + "img/3.9a410104.png";